export enum MetabolicUserType {
    Full = "full",
    Lite = "lite",
    Hook = "hook",
    None = "none",
}